import { render } from "./AboutClient.vue?vue&type=template&id=a8721a58&scoped=true"
import script from "./AboutClient.vue?vue&type=script&lang=js"
export * from "./AboutClient.vue?vue&type=script&lang=js"

import "./AboutClient.vue?vue&type=style&index=0&id=a8721a58&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8721a58"]])

export default __exports__